import { render, staticRenderFns } from "./JsaReminderDelete.vue?vue&type=template&id=0b4261a0"
import script from "./JsaReminderDelete.vue?vue&type=script&lang=js"
export * from "./JsaReminderDelete.vue?vue&type=script&lang=js"
import style0 from "./JsaReminderDelete.vue?vue&type=style&index=0&id=0b4261a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports